<template>
  <div class="topic_list">
    <div class="topic_one mt-15 mb-20" v-for="(item, index) in topicList" :key="index">
      <div class="topic_type">{{ item.questionTypeName }}</div>
      <div class="topic_sub flex FlexWrap">
        <div class="answer_block mt-10 cursor_pointer" v-for="(sitem, sindex) in item.questions" :key="sindex" :class="[
          sitem.isCorrect == 3
            ? 'incomplete_progress'
            : sitem.isCorrect == 1
              ? 'complete_progress'
              : 'wrong_progress',
        ]" @click="showQuestion(item,sitem)">
          {{ sitem.questionNumber }}
        </div>
      </div>
    </div>
    <question-popup ref="questionPopup"></question-popup>
  </div>
</template>

<script>
import questionPopup from '../popup/questionPopup.vue';
export default {
  name: "GjkcH5AnswerSheetAnalysis",
  components:{
    questionPopup
  },

  data() {
    return {
      topicList: [],
    };
  },

  mounted() { },

  methods: {
    showQuestion(info,subInfo){
      subInfo.questionTypeId = info.questionTypeId;
      subInfo.questionTypeName = info.questionTypeName;
      subInfo.showAnalysis = true;
      if(!this.$Tools.empty(subInfo.questionContext.subQuestions)){
        subInfo.questionContext.subQuestions.forEach(sitem=>{
          sitem.showAnalysis = true;
        })
      }
      this.$refs.questionPopup.topicInfo = subInfo;
      this.$refs.questionPopup.questionShow = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.topic_list {
  .topic_one {
    .topic_type {
      color: #333333;
      line-height: 24px;
    }

    .topic_sub {
      .answer_block {
        text-align: center;
        line-height: 24px;
        margin-right: 10px;
      }
    }
  }
}

.incomplete_progress {
  width: 26px;
  height: 26px;
  background: rgba(255, 160, 3, 0.2);
  border-radius: 8px;
  border: 1px solid #ffa003;
  color: #ff8c00;
}

.complete_progress {
  width: 26px;
  height: 26px;
  background: rgba(0, 199, 88, 0.2);
  border-radius: 8px;
  border: 1px solid #00c758;
  color: #00c758;
}

.wrong_progress {
  width: 26px;
  height: 26px;
  background: rgba(255, 20, 20, 0.23);
  border-radius: 8px;
  border: 1px solid #ff1414;
  color: #ff1414;
}
</style>
